<div class="content-container">
  @if (!hasFailed && email(); as email) {
  <h3>{{ 'setUpTwoFactor.email.title' | translate }}</h3>
  <h4>{{ 'setUpTwoFactor.email.text' | translate }}</h4>
  <div class="section-container" style="margin-bottom: 0">
    <div class="section">
      <div class="section-content">
        <h6>
          {{ 'setUpTwoFactor.authenticatorApp.step' | translate: { step: 1 } }}
        </h6>
        <h5>
          {{ 'setUpTwoFactor.email.step1Title' | translate }}
        </h5>
        <p>
          {{ 'setUpTwoFactor.email.step1Email' | translate: { email } }}
        </p>
        @if (wasEmailSent) {
        <p>
          {{ 'setUpTwoFactor.email.countDownText' | translate }}
          @if ((millisecondsRemaining$ | async); as millisecondsRemaining) { @if
          (millisecondsRemaining > 0) {
          <span>
            {{
              'setUpTwoFactor.email.countDownTimer'
                | translate: { time: (millisecondsRemaining | date: 'mm:ss') }
            }}
          </span>
          }} @else {
          <a (click)="onSendEmail()" class="resend-link">
            {{ 'setUpTwoFactor.email.countDownResend' | translate }}
          </a>
          }
        </p>
        } @else {
        <p class="extra-margin">
          {{ 'setUpTwoFactor.email.step1Text' | translate }}
        </p>
        <button
          mat-flat-button
          class="action-button"
          color="primary"
          type="submit"
          (click)="onSendEmail()"
        >
          {{ 'setUpTwoFactor.email.step1Button' | translate }}
        </button>
        }
      </div>
    </div>
    <hr />
    <div class="section">
      <div class="section-content" style="width: 436px">
        <h6>
          {{ 'setUpTwoFactor.authenticatorApp.step' | translate: { step: 2 } }}
        </h6>
        <h5>
          {{ 'setUpTwoFactor.email.step2Title' | translate }}
        </h5>
        <p>
          {{ 'setUpTwoFactor.email.step2Text' | translate }}
        </p>
        <div class="input-container">
          <form [formGroup]="otpForm" (ngSubmit)="onActivate()">
            <mat-form-field appearance="outline">
              <input
                matInput
                name="mfaCode"
                type="text"
                formControlName="mfaCode"
                maxlength="6"
                [placeholder]="
                  'setUpTwoFactor.authenticatorApp.placeholder' | translate
                "
                required
              />
              @if (otpForm.get('mfaCode').hasError('incorrect')) {
              <mat-icon class="error-icon" matSuffix>error_outline</mat-icon>
              }
            </mat-form-field>
            @if (otpForm.get('mfaCode').hasError('incorrect')) {
            <mat-error>{{
              'setUpTwoFactor.mfaInvalidCodeError' | translate
            }}</mat-error>
            }
          </form>

          <button
            mat-flat-button
            class="action-button activate-button"
            color="primary"
            type="submit"
            (click)="onActivate()"
            [disabled]="!otpForm.valid || isLoading"
          >
            @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            {{ 'setUpTwoFactor.authenticatorApp.activate' | translate }}
            }
          </button>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <app-mfa-fail [errorType]="MfaErrors.DEFAULT"></app-mfa-fail>
  }
</div>
